import { fetchData, postData, putData, deleteData } from '@jda/lui-portal-utilities';
import { getAuthToken } from '../auth/authProvider';
import { IRoleMappingRequest } from '../models/RoleMapping/Contracts';
import { createRequestObject, getAPIMUrl } from '../utility/commonUtility';

const { CLIENT_SERVICE_V1_URL } = window['env'];

export const getRoleMappingData = async () => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/idpRoles`;
  return fetchData<any[]>(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const createNewRoleMapping = async (data: IRoleMappingRequest) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/idpRoles`;
  return postData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const updateRoleMapping = async (data: IRoleMappingRequest) => {
  const BASE_APIM_URL = await getAPIMUrl();
  const apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/idpRoles/${data.id}`;
  return putData<any>(createRequestObject(apiURL), data, getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};

export const deleteRoleMappingRequest = async (id: number | string) => {
  const BASE_APIM_URL = await getAPIMUrl();
  let apiURL = `${BASE_APIM_URL}${CLIENT_SERVICE_V1_URL}/idpRoles/${id}`;
  return deleteData(createRequestObject(apiURL), getAuthToken)
    .then(appsResponse => {
      return appsResponse;
    })
    .catch((error: any) => {
      throw error;
    });
};